import type {TFunction} from "i18next";
import {
    Button,
    List,
    ListItem,
    Text,
    Title,
} from "@patternfly/react-core";
import {useEnvironmentWithDonorService} from "../../context.tsx";
import {FORMAT_DATE_ONLY, formatDate} from "../../utils/formatDate.ts";

type DocListItemProps = {
    t: TFunction,
    n: number,
}

function DocListItem ({ t, n }: DocListItemProps) {
    const doc = t(`generalMeetingsDocs${n}href`);
    return doc
        ? (
            <ListItem>
                <Text component="a" href={t(`generalMeetingsDocs${n}href`)} target="_blank" rel="noreferrer noopener">
                    {t(`generalMeetingsDocs${n}`)}
                </Text>
            </ListItem>
        )
        : undefined;
}

export type JoinGeneralMeetingProps = {
    t: TFunction,
    donorIdDigest: string,
}

export function JoinGeneralMeeting({
    t,
    donorIdDigest,
}: JoinGeneralMeetingProps) {
    const context = useEnvironmentWithDonorService();

    const today = new Date();
    const prettyGMDate = formatDate(new Date(t("generalMeetingsDate", {defaultValue: undefined})), context.environment.locale, FORMAT_DATE_ONLY);

    const voteStart = new Date(t("generalMeetingsVoteOpenFrom", { defaultValue: undefined }));
    const voteEnd = new Date(t("generalMeetingsVoteOpenTo", { defaultValue: undefined }));
    const prettyVoteStart = formatDate(voteStart, context.environment.locale, FORMAT_DATE_ONLY);
    const prettyVoteEnd = formatDate(voteEnd, context.environment.locale, FORMAT_DATE_ONLY);

    const isVoteOpen = today >= voteStart && today <= voteEnd;

    return (<>
        <Title size="xl" headingLevel="h2">
            {t("generalMeetingsIntro", { voteStart: prettyVoteStart, voteEnd: prettyVoteEnd })}
        </Title>
        <Text>
            {t("generalMeetingsDocs", { date: prettyGMDate })}
        </Text>
        <List>
            {[1,2,3,4,5].map(n => <DocListItem key={n} t={t} n={n} />).filter(Boolean)}
        </List>
        <Text>
            {t("generalMeetingsAdminElection", { voteStart: prettyVoteStart, voteEnd: prettyVoteEnd })}
        </Text>
        { isVoteOpen
            ? (
                <Text>
                    <Button
                        component="a"
                        href={`https://ag.agirpourlenvironnement.org/vote?id_adh=${donorIdDigest}`}
                        target="_blank"
                        rel="noreferrer noopener"
                    >{t("generalMeetingsDoVote")}</Button>
                </Text>
            )
            : undefined
        }
    </>)
}